import { useState } from "react";
import Layout from "@/components/Layout";
import IlDisiKasa from "@/pages/IlDisiKasa";
import GencerKasa from "@/pages/GencerKasa";
import ToplamKasa from "@/pages/ToplamKasa";

const TABS = [
  { key: "tekhukuk", label: "Tek Hukuk Kasa" },
  { key: "gencer", label: "Gencer Kasa" },
  { key: "toplam", label: "Toplam Kasa" },
];

export default function Kasa() {
  const [tab, setTab] = useState("tekhukuk");
  return (
    <Layout>
      <div className="mb-6">
        <div className="kicker mb-1">YÖNETİM — KASA</div>
        <h1 className="font-heading text-3xl font-bold tracking-tight">Kasa</h1>
        <p className="text-sm text-[#8C8377] mt-1">Tek Hukuk, Gencer ve iki kasanın birleşik özeti. (Sadece yönetici)</p>
      </div>

      <div className="flex gap-1 border-b border-[#E7DECC] mb-6 overflow-x-auto no-scrollbar" data-testid="kasa-tabs">
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            data-testid={`kasa-tab-${t.key}`}
            className={`px-4 py-2.5 text-sm font-medium -mb-px border-b-2 whitespace-nowrap shrink-0 transition-colors duration-150 ${
              tab === t.key
                ? "border-[#B8933F] text-[#B8933F]"
                : "border-transparent text-[#8C8377] hover:text-[#26231E]"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === "tekhukuk" && <IlDisiKasa />}
      {tab === "gencer" && <GencerKasa />}
      {tab === "toplam" && <ToplamKasa />}
    </Layout>
  );
}
